import FieldReadOnly from "../../../../fields3/generic/read-only-value/read-only";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldTaskPredecessor_CSVImportPreview from "./render/csv-import-preview";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";

export default class FieldTaskPredecessors extends FieldReadOnly {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Predecessor Tasks";
        // this.typeGroup          = GROUP_INFO
        // this.typeDescription    = "Task id"

        this.icon               = 'i5-id'

        // this.variableName       = '{TASK-ID}'

        // _.assign(this.renderComponents, {
        //
        //     view                : FieldTaskId_View,
        //     viewSmall           : FieldTaskId_View,
        //
        // })

        this.renderComponents.csvImportPreview  = FieldTaskPredecessor_CSVImportPreview


    }


    // is used to convert value for import from CSV - can be redefined in specific cases
    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {

        const result    : any[] = []

        // Stupid patch to support shortIds
        // regexp because regular replace does it only once
        if (value) {
            value = value.replace(new RegExp("#", 'g'), "")
        }

        // the format for multiple dependecies is
        // dep1, dep2

        const allPredecessors = value.split(",")
        _.map(allPredecessors, (predecessor:string)=>{
            predecessor = predecessor.trim()
            const selfReferenceUID = module.selfReferenceMap[predecessor]
            if (selfReferenceUID) {
                result.push(selfReferenceUID)
            }
        })

        if (_.isEmpty(result)) return null

        // const selfReferenceUID = _.get(module.selfReferenceMap, value, null)
        // const selfReferenceUID = module.selfReferenceMap[value]
        return result
    }

}
